import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  transportStatus: null,
  transportTypes: null,
  transportProviders: null,
  reasonRejectionOptions: null,
  employeesTransportList: null,
  managerTransportList: null,
  driverLogisticTransportList: null,
  transportDrivers: null,
  filtersHasChanged: false,
  acts: null,
  act: null,
  risk: {},
  /* transferAct: null, */
  /* transferActs: null, */
  filtersManagerTransportList: {
    idType: '',
    idState: '',
    plate: ''
  },
  filterEmployeesTransportList: {
    idProvider: '',
    idType: '',
    idState: '',
    plate: ''
  },
  filterDriverTransportList: {
    idType: '',
    idState: '',
    plate: ''
  },
  checklistsExternalBreaks: [],
  offline: {
    risk: {
      documents: null,
      images: null
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
